import { render, staticRenderFns } from "./ToolbarWrapper.vue?vue&type=template&id=4b71fc01&scoped=true"
import script from "./ToolbarWrapper.vue?vue&type=script&lang=js"
export * from "./ToolbarWrapper.vue?vue&type=script&lang=js"
import style0 from "./ToolbarWrapper.vue?vue&type=style&index=0&id=4b71fc01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71fc01",
  null
  
)

export default component.exports